<template>
  <div class="hero-head pb-2">
    <nav class="navbar">
      <div class="container">
        <div class="navbar-brand">
          <div class="is-flex is-flex-direction-row is-align-items-center">
            <router-link v-bind:to="{ name: 'HomePage' }" class="navbar-item">
              <span class="is-size-4 has-text-weight-bold"> RMP </span>
            </router-link>
            <a href="https://india.acm.org/" target="_blank" class="">
              <img src="/assets/logos/acm-india-council.png" style="width: 128px" />
            </a>
          </div>
          <span v-on:click="show_navbar_burger_menu = !show_navbar_burger_menu"
            v-bind:class="{ 'is-active': show_navbar_burger_menu }" class="navbar-burger" data-target="navbarMenuHeroB">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>

        <div v-bind:class="{ 'is-active': show_navbar_burger_menu }" id="navbarMenuHeroB" class="navbar-menu">
          <div class="navbar-end">
            <div v-if="logged_in && user.is_mentor" class="navbar-item">
              <!-- <div v-if="user.is_mentor"> -->
              <router-link v-bind:to="{
                name: 'MentorProfilePage',
                params: { profile_uid: user.profile_uid },
              }" class="navbar-item">
                My Profile
              </router-link>

              <router-link v-bind:to="{ name: 'MyMenteesPage' }" class="navbar-item">
                My Mentees
              </router-link>

              <router-link v-bind:to="{ name: 'MentorPendingRequestsPage' }" class="navbar-item">
                Pending Requests
              </router-link>

              <router-link v-bind:to="{ name: 'MentorProfileSettingsPage' }" class="navbar-item">
                Profile Settings
              </router-link>

              <router-link v-bind:to="{ name: 'MentorSettingsPage' }" class="navbar-item">
                Mentor Preferences
              </router-link>

              <router-link v-bind:to="{ name: 'FAQPage' }" class="navbar-item">
                <span class="icon">
                  <i class="fas fa-question"></i>
                </span>
                <span>FAQs</span>
              </router-link>

              <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                  <span class="icon">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="has-text-weight-bold">
                    {{ user.first_name }}
                  </span>
                </a>

                <div class="navbar-dropdown is-boxed is-right">
                  <div class="navbar-item">
                    Status: 
                    <p v-if="!user.is_verified" style="color: red;"> Not Verified</p>
                    <p v-else-if="user.is_blocked" style="color: red;"> Blocked</p>
                    <p v-else style="color: green;"> Activated</p>
                  </div>
                  <router-link v-bind:to="{
                    name: 'MentorMessages',
                    params: { profile_uid: user.profile_uid },
                  }" class="navbar-item"
                  v-on:click="messages_read">
                    Contact Admin ({{ unread_messages }})
                  </router-link>
                  <router-link v-bind:to="{
                    name: 'ChangePasswordPage',
                    params: { profile_uid: user.profile_uid },
                  }" class="navbar-item">
                    Change Password
                  </router-link>

                  <hr class="navbar-divider" />

                  <a v-on:click="logout" class="navbar-item">
                    <span class="icon">
                      <i class="fas fa-sign-out-alt"></i>
                    </span>
                    <span>Logout</span>
                  </a>
                </div>
              </div>
            </div>
            <div v-else-if="logged_in && user.is_mentee" class="navbar-item">
              <router-link v-bind:to="{ name: 'MenteeProfilePage' }" class="navbar-item">
                My Profile
              </router-link>

              <router-link v-bind:to="{ name: 'MyMentorsPage' }" class="navbar-item">
                My Mentors
              </router-link>

              <router-link v-bind:to="{ name: 'FindMentorPage' }" class="navbar-item">
                Find Mentor
              </router-link>

              <router-link v-bind:to="{ name: 'MenteePendingRequestsPage' }" class="navbar-item">
                Pending Requests
              </router-link>

              <router-link v-bind:to="{ name: 'MenteeProfileSettingsPage' }" class="navbar-item">
                Profile Settings
              </router-link>
              <!-- </div> -->
              <router-link v-bind:to="{ name: 'FAQPage' }" class="navbar-item">
                <span class="icon">
                  <i class="fas fa-question"></i>
                </span>
                <span>FAQs</span>
              </router-link>
              
              <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                  <span class="icon">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="has-text-weight-bold">
                    {{ user.first_name }}
                  </span>
                </a>

                <div class="navbar-dropdown is-boxed is-right">
                  <div class="navbar-item">
                    Status: 
                    <p v-if="user.is_blocked" style="color: red;"> Blocked</p>
                    <p v-else style="color: green;"> Activated</p>
                  </div>
                  <router-link v-bind:to="{
                    name: 'MenteeMessages',
                    params: { profile_uid: user.profile_uid },
                  }" class="navbar-item"
                  v-on:click="messages_read">
                    Contact Admin ({{ unread_messages }})
                  </router-link>
                  <router-link v-bind:to="{
                    name: 'ChangePasswordPage',
                    params: { profile_uid: user.profile_uid },
                  }" class="navbar-item">
                    Change Password
                  </router-link>

                  <hr class="navbar-divider" />

                  <a v-on:click="logout" class="navbar-item">
                    <span class="icon">
                      <i class="fas fa-sign-out-alt"></i>
                    </span>
                    <span>Logout</span>
                  </a>
                </div>
              </div>
            </div>
            <div v-else-if="user.is_rfc && logged_in" class="navbar-item">
              <router-link v-bind:to="{ name: 'VerifyMentorPage' }" class="navbar-item">
                Verify Mentor
              </router-link>
              <router-link v-bind:to="{ name: 'MentorAnalyticsPage' }" class="navbar-item">
                Mentors
              </router-link>
              <router-link v-bind:to="{ name: 'MenteesPage' }" class="navbar-item">
                Mentees
              </router-link>
              <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                  <span class="icon">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="has-text-weight-bold">
                    {{ user.first_name }}
                  </span>
                </a>

                <div class="navbar-dropdown is-boxed is-right">
                  <router-link v-bind:to="{
                    name: 'ChangePasswordPage',
                    params: { profile_uid: user.profile_uid },
                  }" class="navbar-item">
                    Change Password
                  </router-link>

                  <hr class="navbar-divider" />

                  <a v-on:click="logout" class="navbar-item">
                    <span class="icon">
                      <i class="fas fa-sign-out-alt"></i>
                    </span>
                    <span>Logout</span>
                  </a>
                </div>
              </div>
            </div>
            <div v-else class="navbar-item">


             <router-link
                v-bind:to="{ name: 'SearchMentor' }"
                class="navbar-item"
              >
                <span class="icon">
                  <i class="fas fa-search"></i>
                </span>
                <span>Search Mentor </span>
              </router-link>


              <router-link v-bind:to="{ name: 'FAQPage' }" class="navbar-item">
                <span class="icon">
                  <i class="fas fa-question"></i>
                </span>
                <span>FAQs</span>
              </router-link>

              <router-link v-bind:to="{ name: 'LoginPage' }" class="navbar-item">
                <span class="icon">
                  <i class="fas fa-sign-in-alt"></i>
                </span>
                <span>Login</span>
              </router-link>

              <div class="navbar-item has-dropdown is-hoverable pl-2">
                <a class="navbar-link">
                  <span class="icon pr-1">
                    <i class="fas fa-user-plus"></i>
                  </span>
                  <span>Register</span>
                </a>

                <div class="navbar-dropdown">
                  <router-link v-bind:to="{ name: 'RegisterMentorPage' }" class="navbar-item">
                    As Mentor
                  </router-link>
                  <router-link v-bind:to="{ name: 'RegisterMenteePage' }" class="navbar-item">
                    As Mentee
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios from '../api/my-axios';

export default {
  computed: {
    ...mapGetters({
      logged_in: 'logged_in',
    }),
    ...mapState({
      user: 'user',
    }),
  },
  data() {
    return {
      show_navbar_burger_menu: false,
      unread_messages: 0
    };
  },
  created() {
    this.get_user();
  },
  methods: {
    logout() {
      this.$store.dispatch('logout_user');
      this.$router.replace({ name: 'HomePage' });
    },

    messages_read(){
      this.unread_messages = 0;
    },

    get_user(){
      if (this.logged_in){
        axios
          .get(`/api/users/user/${this.user.uid}/`)
          .then(user_data => {
            // console.log(user_data.data)
            user_data.data.profile_uid = this.user.profile_uid;
            this.$store.commit("set_user", user_data.data);
            this.$store.commit("set_email_verified", false);
            this.unread_messages = user_data.data.unread_messages;
          })
          .catch(error => {
            // console.log(error)
            // this.errors = error.response ? error.response.data : {"detail": error.message};
          });
      }
    }
  },
};
</script>
